export default function CentreBankingApi({ makeRequest, buildRequest, baseUrl = '' }) {
    
    function getSignalRConnection() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/api/SignalR/negotiate`));
        });
    }



    return {
        getSignalRConnection
    }

}